import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=620519da&"
import script from "./HelpModal.vue?vue&type=script&lang=js&"
export * from "./HelpModal.vue?vue&type=script&lang=js&"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=620519da&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620519da')) {
      api.createRecord('620519da', component.options)
    } else {
      api.reload('620519da', component.options)
    }
    module.hot.accept("./HelpModal.vue?vue&type=template&id=620519da&", function () {
      api.rerender('620519da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/HelpModal.vue"
export default component.exports